import React, { useState } from 'react';
import axios from 'axios';
import '../styles/BusinessForm.css';

const BusinessForm = ({ onBusinessAdded, onCancel }) => {
  const [formData, setFormData] = useState({
    bis_name: '',
    bis_phone: '',
    bis_country: 'Mexico',
    bis_timezone: 'America/Mexico_City'
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const countries = ['Mexico', 'Argentina', 'Bolivia', 'Brasil', 'Chile', 'Colombia', 'Costa Rica', 'Cuba', 'Republica Dominicana', 'Ecuador', 'El Salvador', 'Guatemala', 'Honduras', 'Nicaragua', 'Panama', 'Paraguay', 'Peru', 'Uruguay', 'Venezuela'];

  const timezones = [
    'America/Argentina/Buenos_Aires',
    'America/La_Paz',
    'America/Santiago',
    'America/Bogota',
    'America/Costa_Rica',
    'America/Havana',
    'America/Santo_Domingo',
    'America/Guayaquil',
    'Pacific/Galapagos',
    'America/El_Salvador',
    'America/Guatemala',
    'America/Tegucigalpa',
    'America/Mexico_City',
    'America/Cancun',
    'America/Chihuahua',
    'America/Hermosillo',
    'America/Mazatlan',
    'America/Monterrey',
    'America/Tijuana',
    'America/Managua',
    'America/Panama',
    'America/Asuncion',
    'America/Lima',
    'America/Puerto_Rico',
    'America/Montevideo',
    'America/Caracas'
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem('token');
      const response = await axios.post('/api/businesses', formData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      setLoading(false);
      // Pasar el negocio creado al componente padre y un indicador para abrir el formulario de punto de venta
      onBusinessAdded(response.data, true);
    } catch (error) {
      setLoading(false);
      setError(error.response?.data?.error || 'Error al crear el negocio. Por favor intente nuevamente.');
      console.error('Error creating business:', error);
    }
  };

  return (
    <div className="business-form-container">
      <h2>Agregar tu negocio</h2>
      {error && <div className="error-message">{error}</div>}
      <form onSubmit={handleSubmit} className="business-form">
        <div className="form-group">
          <label htmlFor="bis_name">Nombre del Negocio <span className="required-field">*</span></label>
          <input
            type="text"
            id="bis_name"
            name="bis_name"
            value={formData.bis_name}
            onChange={handleChange}
            required
            placeholder="Nombre de tu negocio"
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="bis_phone">Teléfono <span className="required-field">*</span></label>
          <input
            type="tel"
            id="bis_phone"
            name="bis_phone"
            value={formData.bis_phone}
            onChange={handleChange}
            required
            placeholder="Número de teléfono"
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="bis_country">País</label>
          <select
            id="bis_country"
            name="bis_country"
            value={formData.bis_country}
            onChange={handleChange}
            required
          >
            {countries.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
        </div>
        
        <div className="form-group">
          <label htmlFor="bis_timezone">Selecciona el Uso Horario</label>
          <select
            id="bis_timezone"
            name="bis_timezone"
            value={formData.bis_timezone}
            onChange={handleChange}
            required
          >
            {timezones.map((timezone) => (
              <option key={timezone} value={timezone}>
                {timezone}
              </option>
            ))}
          </select>
        </div>
        
        <div className="form-actions">
          <button type="button" onClick={onCancel} className="cancel-btn">
            Cancelar
          </button>
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? 'Guardando...' : 'Guardar Negocio'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default BusinessForm;
